module.exports = __webpack_public_path__ + "static/dotgrid-0ba06433bb705667c35f5afec9018594.png";